// import React, { useState, useEffect } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { FaGlobe, FaCheck, FaTimes } from "react-icons/fa";
// import Navbar from "../components/Navbar";
// import LogoPiaWak from "../utils/register.png";
// import { useLanguage } from "../components/LanguajeContext";
// import { translation } from "../utils/resetpassword.translate";

// export default function ResetPassword() {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   //const [language, setLanguage] = useState("es");
//   const [token, setToken] = useState("");
//   const [email, setEmail] = useState("");
//   const URL = process.env.REACT_APP_SERVER_URL;
//   const { language } = useLanguage();
//   const t=translation[language]
//   const [formData, setFormData] = useState({
//     password: "",
//     confirmPassword: "",
//   });

//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [passwordMismatch, setPasswordMismatch] = useState(false);
//   const [passwordValidations, setPasswordValidations] = useState({
//     hasMinLength: false,
//     hasUppercase: false,
//     hasLowercase: false,
//     hasNumber: false,
//     hasSpecialChar: false,
//     hasNoSpaces: true,
//   });


//   const validatePassword = (password) => {
//     const validations = {
//       hasMinLength: password.length >= 8,
//       hasUppercase: /[A-Z]/.test(password),
//       hasLowercase: /[a-z]/.test(password),
//       hasNumber: /[0-9]/.test(password),
//       hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
//       hasNoSpaces: !/\s/.test(password),
//     };
//     setPasswordValidations(validations);
//     return Object.values(validations).every(Boolean);
//   };

//   useEffect(() => {
//     const tokenParam = searchParams.get("token");
//     const emailParam = searchParams.get("email");

//     if (!tokenParam) {
//       setError(t.tokenExpired);
//       return;
//     }

//     setToken(tokenParam);
//     setEmail(emailParam);
//   }, [searchParams, t.tokenExpired]);

//   useEffect(() => {
//     if (formData.password) {
//       validatePassword(formData.password);
//     }
    
//     if (formData.password && formData.confirmPassword) {
//       setPasswordMismatch(formData.password !== formData.confirmPassword);
//     }
//   }, [formData.password, formData.confirmPassword]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validatePassword(formData.password)) {
//       setError("La contraseña no cumple con todos los requisitos");
//       return;
//     }

//     if (passwordMismatch) {
//       setError(t.passwordError);
//       return;
//     }

//     setLoading(true);
//     setError("");

//     try {
//       const response = await fetch(`${URL}/api/authOperator/reset-password`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           token: token,
//           newPassword: formData.password
//         }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message || t.errorMessage);
//       }

//       setSuccess(true);
//       setTimeout(() => {
//         navigate("/login");
//       }, 3000);
//     } catch (err) {
//       console.error("Error:", err);
//       setError(err.message || t.errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const inputClass = "w-full p-3 rounded-xl bg-white border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 placeholder-gray-400 text-sm transition duration-200";
//   const errorInputClass = "w-full p-3 rounded-xl bg-white border border-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 placeholder-gray-400 text-sm transition duration-200";

//   if (error && error === t.tokenExpired) {
//     return (
//       <div className="min-h-screen bg-white flex items-center justify-center p-4">
//         <div className="bg-white text-gray-700 w-full max-w-md rounded-3xl shadow-xl overflow-hidden p-8 text-center">
//           <h2 className="text-2xl font-bold text-red-600 mb-4">{t.tokenExpired}</h2>
//           <p className="mb-6">Por favor solicita un nuevo enlace de restablecimiento.</p>
//           <button
//             onClick={() => navigate("/forgot-password")}
//             className="w-full bg-[#0F4C5C] text-white font-semibold py-3 rounded-xl shadow hover:bg-[#0d3a49] transition"
//           >
//             Solicitar nuevo enlace
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Navbar />
//       <div className="min-h-screen bg-white from-white flex items-center justify-center p-20">
//         <div className="bg-white text-gray-700 w-full max-w-5xl rounded-3xl shadow-xl overflow-hidden animate-fade-in mt-3">
//           <div className="grid grid-cols-1 md:grid-cols-2">
//             {/* Left */}
//             <div className="relative bg-[#2D4A5E] p-10 flex flex-col justify-center items-center text-white">
//               <img src={LogoPiaWak} alt="Pia Wak Logo" className="w-40 h-40 object-contain mb-6 animate-fade-in" />
//               <h2 className="text-2xl font-bold text-center">{t.title}</h2>
//               <p className="text-center mt-2 text-sm text-gray-200">{t.subtitle}</p>


//             </div>

//             {/* Right */}
//             <div className="p-10">
//               <h2 className="text-3xl font-bold mb-6 text-center text-[#0F4C5C]">{t.title}</h2>
//               {success ? (
//                 <div className="text-center p-6 bg-green-100 text-green-700 rounded-lg">
//                   <p className="font-semibold">{t.successMessage}</p>
//                 </div>
//               ) : (
//                 <form onSubmit={handleSubmit} className="space-y-4">
//                   <div>
//                     <input
//                       type="password"
//                       name="password"
//                       value={formData.password}
//                       onChange={handleChange}
//                       placeholder={t.newPassword}
//                       className={passwordMismatch && formData.confirmPassword ? errorInputClass : inputClass}
//                       required
//                     />
                    
//                     {/* Indicadores de validación de contraseña */}
//                     {formData.password && (
//                       <div className="mt-2 p-3 bg-gray-50 rounded-lg">
//                         <p className="text-sm font-medium mb-2">{t.passwordRequirements}</p>
//                         <ul className="text-xs space-y-1">
//                           <li className={`flex items-center ${passwordValidations.hasMinLength ? 'text-green-600' : 'text-red-600'}`}>
//                             {passwordValidations.hasMinLength ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
//                             {t.minLength}
//                           </li>
//                           <li className={`flex items-center ${passwordValidations.hasUppercase ? 'text-green-600' : 'text-red-600'}`}>
//                             {passwordValidations.hasUppercase ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
//                             {t.uppercase}
//                           </li>
//                           <li className={`flex items-center ${passwordValidations.hasLowercase ? 'text-green-600' : 'text-red-600'}`}>
//                             {passwordValidations.hasLowercase ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
//                             {t.lowercase}
//                           </li>
//                           <li className={`flex items-center ${passwordValidations.hasNumber ? 'text-green-600' : 'text-red-600'}`}>
//                             {passwordValidations.hasNumber ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
//                             {t.number}
//                           </li>
//                           <li className={`flex items-center ${passwordValidations.hasSpecialChar ? 'text-green-600' : 'text-red-600'}`}>
//                             {passwordValidations.hasSpecialChar ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
//                             {t.specialChar}
//                           </li>
//                           <li className={`flex items-center ${passwordValidations.hasNoSpaces ? 'text-green-600' : 'text-red-600'}`}>
//                             {passwordValidations.hasNoSpaces ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
//                             {t.noSpaces}
//                           </li>
//                         </ul>
//                       </div>
//                     )}
//                   </div>
                  
//                   <input
//                     type="password"
//                     name="confirmPassword"
//                     value={formData.confirmPassword}
//                     onChange={handleChange}
//                     placeholder={t.confirmPassword}
//                     className={passwordMismatch ? errorInputClass : inputClass}
//                     required
//                   />

//                   {error && (
//                     <div className="text-red-600 bg-red-100 border border-red-300 p-2 rounded-lg text-sm">
//                       <p className="text-center">{error}</p>
//                     </div>
//                   )}

//                   <button
//                     type="submit"
//                     disabled={loading || passwordMismatch || !Object.values(passwordValidations).every(Boolean)}
//                     className={`w-full mt-6 font-semibold py-3 rounded-xl shadow transition-all duration-200 ${
//                       loading || passwordMismatch || !Object.values(passwordValidations).every(Boolean)
//                         ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                         : "bg-[#0F4C5C] text-white hover:bg-[#0d3a49]"
//                     }`}
//                   >
//                     {loading ? (
//                       <span className="flex items-center justify-center">
//                         <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                         </svg>
//                         {t.resetButton}
//                       </span>
//                     ) : (
//                       t.resetButton
//                     )}
//                   </button>
//                 </form>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaCheck, FaTimes } from "react-icons/fa";
import Navbar from "../components/Navbar";
import LogoPiaWak from "../utils/register.png";
import { useLanguage } from "../components/LanguajeContext";
import { translation } from "../utils/resetpassword.translate";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { language } = useLanguage();
  const t = translation[language];
  console.log("languaje", language)

  const URL = process.env.REACT_APP_SERVER_URL;

  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [passwordValidations, setPasswordValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
    noSpaces: true,
  });

  const [passwordMismatch, setPasswordMismatch] = useState(false);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  // ⭐ Mismas reglas que OperatorRegister
  const validatePassword = (password) => {
    const validations = {
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      noSpaces: !/\s/.test(password),
    };

    setPasswordValidations(validations);

    return Object.values(validations).every(Boolean);
  };

  useEffect(() => {
    const tokenParam = searchParams.get("token");
    const emailParam = searchParams.get("email");

    if (!tokenParam) {
      setError(t.tokenExpired);
      return;
    }

    setToken(tokenParam);
    setEmail(emailParam);
  }, [searchParams, t.tokenExpired]);

  useEffect(() => {
    if (formData.password) validatePassword(formData.password);

    if (formData.password && formData.confirmPassword) {
      setPasswordMismatch(formData.password !== formData.confirmPassword);
    }
  }, [formData.password, formData.confirmPassword]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword(formData.password)) {
      setError(t.passwordInvalid);
      return;
    }

    if (passwordMismatch) {
      setError(t.passwordError);
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${URL}/api/authOperator/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: token,
          newPassword: formData.password,
        }),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.message || t.errorMessage);

      setSuccess(true);

      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      console.error("Error:", err);
      setError(err.message || t.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full p-3 rounded-xl bg-white border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 placeholder-gray-400 text-sm transition duration-200";
  const errorInputClass =
    "w-full p-3 rounded-xl bg-white border border-red-500 focus:outline-none focus:ring-2 focus:ring-red-400 placeholder-gray-400 text-sm transition duration-200";

  // Si el token expiró
  if (error && error === t.tokenExpired) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4">
        <div className="bg-white text-gray-700 w-full max-w-md rounded-3xl shadow-xl overflow-hidden p-8 text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">{t.tokenExpired}</h2>
          <p className="mb-6">{t.requestNewLink}</p>
          <button
            onClick={() => navigate("/forgot-password")}
            className="w-full bg-[#0F4C5C] text-white font-semibold py-3 rounded-xl shadow hover:bg-[#0d3a49] transition"
          >
            {t.requestButton}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Navbar />

      <div className="min-h-screen bg-white flex items-center justify-center p-20">
        <div className="bg-white text-gray-700 w-full max-w-5xl rounded-3xl shadow-xl overflow-hidden animate-fade-in mt-3">
          <div className="grid grid-cols-1 md:grid-cols-2">

            {/* Left Panel */}
            <div className="relative bg-[#2D4A5E] p-10 flex flex-col justify-center items-center text-white">
              <img src={LogoPiaWak} alt="Pia Wak Logo" className="w-40 h-40 object-contain mb-6 animate-fade-in" />
              <h2 className="text-2xl font-bold text-center">{t.title}</h2>
              <p className="text-center mt-2 text-sm text-gray-200">{t.subtitle}</p>
            </div>

            {/* Right Panel */}
            <div className="p-10">
              <h2 className="text-3xl font-bold mb-6 text-center text-[#0F4C5C]">{t.title}</h2>

              {/* SUCCESS */}
              {success ? (
                <div className="text-center p-6 bg-green-100 text-green-700 rounded-lg">
                  <p className="font-semibold">{t.successMessage}</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">

                  {/* Password Input */}
                  <div>
                    <input
                      type="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      placeholder={t.newPassword}
                      className={
                        passwordMismatch && formData.confirmPassword
                          ? errorInputClass
                          : inputClass
                      }
                      required
                    />

                    {/* Password Rules */}
                    {formData.password && (
                      <div className="mt-2 p-3 bg-gray-50 rounded-lg">
                        <p className="text-sm font-medium mb-2">{t.passwordRequirements}</p>

                        <ul className="text-xs space-y-1">
                          <li className={`flex items-center ${passwordValidations.length ? "text-green-600" : "text-red-600"}`}>
                            {passwordValidations.length ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
                            {t.minLength}
                          </li>

                          <li className={`flex items-center ${passwordValidations.uppercase ? "text-green-600" : "text-red-600"}`}>
                            {passwordValidations.uppercase ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
                            {t.uppercase}
                          </li>

                          <li className={`flex items-center ${passwordValidations.lowercase ? "text-green-600" : "text-red-600"}`}>
                            {passwordValidations.lowercase ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
                            {t.lowercase}
                          </li>

                          <li className={`flex items-center ${passwordValidations.number ? "text-green-600" : "text-red-600"}`}>
                            {passwordValidations.number ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
                            {t.number}
                          </li>

                          <li className={`flex items-center ${passwordValidations.specialChar ? "text-green-600" : "text-red-600"}`}>
                            {passwordValidations.specialChar ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
                            {t.specialChar}
                          </li>

                          <li className={`flex items-center ${passwordValidations.noSpaces ? "text-green-600" : "text-red-600"}`}>
                            {passwordValidations.noSpaces ? <FaCheck className="mr-1" /> : <FaTimes className="mr-1" />}
                            {t.noSpaces}
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    placeholder={t.confirmPassword}
                    className={passwordMismatch ? errorInputClass : inputClass}
                    required
                  />

                  {/* ERROR */}
                  {error && (
                    <div className="text-red-600 bg-red-100 border border-red-300 p-2 rounded-lg text-sm">
                      <p className="text-center">{error}</p>
                    </div>
                  )}

                  {/* Submit button */}
                  <button
                    type="submit"
                    disabled={
                      loading ||
                      passwordMismatch ||
                      !Object.values(passwordValidations).every(Boolean)
                    }
                    className={`w-full mt-6 font-semibold py-3 rounded-xl shadow transition-all duration-200 ${
                      loading ||
                      passwordMismatch ||
                      !Object.values(passwordValidations).every(Boolean)
                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                        : "bg-[#0F4C5C] text-white hover:bg-[#0d3a49]"
                    }`}
                  >
                    {loading ? (
                      <span className="flex items-center justify-center">
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        {t.resetButton}
                      </span>
                    ) : (
                      t.resetButton
                    )}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

